import { gql } from '@apollo/client';
import {VEHICLE_TYPE_DETAIL_FIELDS, VEHICLE_TYPE_FIELDS, VehicleType, VehicleTypeDetail} from '../../../../../graphql/types/VehicleType';

export const GET_VEHICLES = gql`
  query GetVehicles($licensePlate: String, $vehicleTypeId: Long, $fuelType: Int, $status: Int, $warehouseId: Long!) {
    allVehicles: getVehicles(
      licensePlate: $licensePlate
      vehicleTypeId: $vehicleTypeId
      fuelType: $fuelType
      status: $status
      warehouseId: $warehouseId
    ) {
      ...VehicleTypeFields
    }
  }
  ${VEHICLE_TYPE_FIELDS}
`;

export const FIND_VEHICLE_BY_ID = gql`
  query FindVehicleById($id: Long!) {
    findVehicleById(id: $id) {
      ...VehicleTypeDetailFields
    }
  }
  ${VEHICLE_TYPE_DETAIL_FIELDS}
`;

export interface VehiclesResponse {
  allVehicles: VehicleType[];
}

export interface FindVehicleByIdResponse {
  findVehicleById: VehicleTypeDetail;
}
